import styled from 'styled-components';

const DesktopContainer = styled('div')`
  @media (max-width: ${(props) => props.theme.breakpoints.lg}) {
    display: none;
  }
`;

export default DesktopContainer;
